import {
  GET_METADATAS_REQUEST,
  GET_METADATAS_SUCCESS,
  GET_METADATAS_FAILURE,
  UPDATE_METADATA_REQUEST,
  UPDATE_METADATA_SUCCESS,
  UPDATE_METADATA_FAILURE,
  DELETE_METADATA_REQUEST,
  DELETE_METADATA_SUCCESS,
  DELETE_METADATA_FAILURE
} from "src/actions/metaDataActions";
import produce from "immer";

const initialState = {
  metadatas: [],
  metadata: {},
  total: 0,
  loading: false
};

const metaDataReducer = (state = initialState, action) => {
  // get list case
  switch (action.type) {
    case GET_METADATAS_REQUEST: {
      return produce(state, (draft) => {
        draft.metadatas = [];
        draft.loading = true;
      });
    }

    case GET_METADATAS_SUCCESS: {
      const {response, total} = action.payload;
      return produce(state, (draft) => {
        draft.metadatas = response;
        draft.total = total;
        draft.loading = false;
      });
    }

    case GET_METADATAS_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    // UPDATE case
    case UPDATE_METADATA_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case UPDATE_METADATA_SUCCESS: {
      const {response} = action.payload;
      const updateObj = state.metadatas.map((item) => {
        if (item.id === response.id) return response;
        return item;
      });

      if (updateObj !== undefined && updateObj.length > 0) {
        return produce(state, (draft) => {
          draft.metadatas = updateObj;
          draft.loading = false;
        });
      }
      return produce(state, (draft) => {
        draft.metadatas = [response];
        draft.loading = false;
      });
    }

    case UPDATE_METADATA_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    // DELETE case
    case DELETE_METADATA_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case DELETE_METADATA_SUCCESS: {
      const {data} = action.payload;

      return produce(state, (draft) => {
        const {metadatas} = draft;
        let filteredMetadatas;
        if (typeof data === "object") {
          filteredMetadatas = metadatas.filter((item) => item.id !== data.id);
        } else {
          filteredMetadatas = metadatas.filter((item) => item.id !== data);
        }

        draft.total -= 1;
        draft.metadatas = filteredMetadatas;
        draft.loading = false;
      });
    }

    case DELETE_METADATA_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    default: {
      return state; // We return the default state here
    }
  }
};

export default metaDataReducer;
